import React from 'react';

const MATURITY_LEVELS = [
  { key: 'TRADITIONAL', label: 'TRAD', color: 'var(--zt-traditional)' },
  { key: 'INITIAL', label: 'INIT', color: 'var(--zt-initial)' },
  { key: 'ADVANCED', label: 'ADV', color: 'var(--zt-advanced)' },
  { key: 'OPTIMAL', label: 'OPT', color: 'var(--zt-optimal)' }
];

const MaturityBar = ({ currentMaturity, onSelect, interactive = false, compact = false }) => {
  const currentIndex = MATURITY_LEVELS.findIndex(m => m.key === currentMaturity);

  return (
    <div className={`maturity-bar ${compact ? 'maturity-bar--compact' : ''} ${interactive ? 'maturity-bar--interactive' : ''}`}>
      {MATURITY_LEVELS.map((level, idx) => {
        const isActive = level.key === currentMaturity;
        const isFilled = currentIndex >= 0 && idx <= currentIndex;

        return (
          <button
            key={level.key}
            className={`maturity-segment ${isFilled ? 'filled' : ''} ${isActive ? 'active' : ''}`}
            style={{
              backgroundColor: isFilled ? level.color : undefined,
              borderColor: isActive ? level.color : undefined,
              cursor: interactive ? 'pointer' : 'default'
            }}
            onClick={interactive && onSelect ? () => onSelect(level.key) : undefined}
            disabled={!interactive}
            title={level.key}
            aria-label={`${level.key}${isActive ? ' (current)' : ''}`}
            aria-pressed={isActive}
          >
            {!compact && <span className="maturity-segment-label">{level.label}</span>}
          </button>
        );
      })}
    </div>
  );
};

export default MaturityBar;
